import React from 'react';
import { StyledLink } from './elements';
import { useText, useLink } from 'common/hooks';

export function DuckyLogo({
  height = '40px',
  disabled = false,
}: {
  readonly height?: string;
  readonly disabled?: boolean;
}) {
  const t = useText();
  const link = useLink();

  return (
    <StyledLink
      href={disabled ? undefined : link('')}
      role="menuitem"
      aria-label={t('menu.home')}
    >
      <img
        src={'https://static.ducky.eco/images/logos/ducky.svg'}
        height={height}
      />
    </StyledLink>
  );
}
